import React, { useContext, useEffect, useState } from 'react';
import { Container, Row, Col, Button, Form, Nav, Card, Navbar, Modal } from "react-bootstrap";
import "./styles.css";
import Footer from './../Footer';
import { motion } from "framer-motion";
import { FaSearch, FaAngleDoubleRight, FaBars, FaHeart, FaAngleRight, FaMapMarkerAlt, FaHome, FaList } from "react-icons/fa";

import { ChartNoAxesCombined, Landmark, ReceiptIndianRupee, Star, IndianRupee, Banknote, Handshake, CalendarClock, Ban } from "lucide-react";
import 'bootstrap/dist/css/bootstrap.min.css';
import { IoNotifications } from "react-icons/io5";
import { Gauge } from '@mui/x-charts/Gauge';
import { Player } from '@lottiefiles/react-lottie-player';
import { AuthContext } from './../AuthContext';
import { parseStoredAccessToken } from '../parseStoredAccessToken.js';
import { parseWalletAmount } from '../parseWalletAmount.js';
import axios from 'axios';
import { site_url, site_url_img } from "../config.js";
// import { FaAngleRight } from "react-icons/fa";
import { FaMapMarkedAlt, FaWhatsapp, FaPhoneAlt, FaArrowLeft } from "react-icons/fa";

import { Link } from "react-router-dom";
import { Navigate, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';

import FloatRefreshButton from '../FloatRefreshButton';




function Index() {
  const [categorydata, setcategorydata] = useState([]);
  const { user, fulluser } = useContext(AuthContext);
  const [show, setShow] = useState(false);
  const [paymentdetails, setpaymentdetails] = useState([]);
  const [UserActivity, setUserActivity] = useState(null);
  const [isChecked, setIsChecked] = useState(false);
  const [isChecked2, setIsChecked2] = useState(false);
  const [remarks, setRemarks] = useState('');

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleCheckboxChange = (e) => {
    setIsChecked(e.target.checked);
    setIsChecked2(e.target.checked); // Set both together for combined wallet
    console.log('Reward Wallet Checked:', e.target.checked);
  };
  const goBack = () => {
    window.history.back(); // Goes back to the previous page
  };


  const makePayment = async () => {
    try {
      const res = await axios.post(site_url + "/payonlineorder", {
        amount: paymentdetails?.billamount,
        order_id: paymentdetails?.id,
        isChecked: isChecked ? '1' : '0',
        isChecked2: isChecked2 ? '1' : '0',
        remarks: remarks || '',
      });

      if (res.data.status === 'redeem') {
        setShow(false);
        getUserdetails();
        Swal.fire('Success', 'Bill paid using wallet balance.', 'success');
        return;
      }

      if (res.data.status === 'error' && res.data.message) {
        alert(res.data.message);
        return;
      }




      const { razorpay_key, order_id, amount, currency } = res.data;
      if (!razorpay_key) {
        alert("Missing Razorpay key from server.");
        return;
      }
      const options = {
        key: razorpay_key,
        amount: amount,
        currency: currency,
        name: "APM",
        description: "Test Transaction",
        order_id: order_id,
        handler: async function (response) {
          try {
            const token = parseStoredAccessToken(user); // assuming 'user' contains the token as stringified

            if (token) {
              const res = await axios.post(
                site_url + "/verify-payment",
                {
                  razorpay_payment_id: response.razorpay_payment_id,
                  oid: paymentdetails?.id,
                  isChecked: isChecked ? '1' : '0',
                  isChecked2: isChecked2 ? '1' : '0',
                  used_wallet: appliedWallet,
                  remarks: remarks || ''
                },
                {
                  headers: {
                    Authorization: `Bearer ${token}`,
                    Accept: 'application/json'
                  }
                }
              );


              if (res.data.status === 'success') {
                setShow(false);
                getUserdetails();
                Swal.fire('Success', 'Payment verified successfully!', 'success');
              } else {
                Swal.fire('Payment Failed', res.data.message || 'Payment verification failed. Please check your transaction history.', 'error');
              }

            } else {
              console.warn("Token missing");
            }
          } catch (err) {
            console.error("API Error:", err?.response?.data || err.message);
            Swal.fire('Error', err?.response?.data?.message || 'Verification error occurred.', 'error');
          }
        },
        prefill: {
          name: fulluser?.username,
          email: "saravanan@example.com",
          contact: fulluser?.phone
        },
        theme: {
          color: "#3399cc"
        },
        modal: {
          ondismiss: function () {
            console.log('Payment modal closed by user');
            // Optional: Inform server that modal was closed
          }
        }
      };

      const rzp = new window.Razorpay(options);
      rzp.on('payment.failed', function (response) {
        console.error("Payment failed:", response.error);
        Swal.fire('Payment Failed', `Reason: ${response.error.description}`, 'error');
      });
      rzp.open();
    } catch (err) {
      if (err.response?.data?.message) {
        Swal.fire('Error', err.response.data.message, 'error');
      } else {
        Swal.fire('Error', 'An error occurred while initiating payment.', 'error');
      }
    }
  };


  const getUserdetails = async () => {
    const token = parseStoredAccessToken(user);
    if (token) {
      axios.get(site_url + "/customer_details", {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: 'application/json'
        }
      })
        .then(res => {
          if (res.data.status == 'success') {
            setUserActivity(res.data);
          } else {

          }
        })
        .catch(err => {
          console.error("API Error:", err.response.data);
        });
    }
  };

  const userpayrequest = async () => {
    const token = parseStoredAccessToken(user);

    if (token) {
      axios.get(site_url + "/userpayrequest", {
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: 'application/json'
        }
      })
        .then(res => {

          if (res.data.status == 'success') {
            setShow(true);
            setpaymentdetails(res.data.data);
          } else {

            setShow(false);
          }
        })
        .catch(err => {
          console.error("API Error:", err.response.data);
        });
    }
  };


  useEffect(() => {
    // userpayrequest();
    // const interval = setInterval(() => {
    userpayrequest();
    // }, 3000); 

    // return () => clearInterval(interval); 
  }, [user]);

  const handleRefresh = () => {
    // Reload your data here
    userpayrequest();
    // Example: fetchData()
  };

  useEffect(() => {
    const shopcategory = async () => {
      try {
        const response = await axios.get(site_url + '/vendor/shopcategory');
        if (response.data.status == 'success') {
          setcategorydata(response.data.category);
        }
      } catch (error) {
      }
    }

    shopcategory();

  }, [])


  useEffect(() => {
    getUserdetails();
  }, [user]);
  const walletBalance = parseWalletAmount(
    UserActivity?.data?.wallet_balance
    ?? UserActivity?.data?.redemption_total
  );
  const billAmount = parseFloat(paymentdetails?.billamount || 0) || 0;
  const appliedWallet = isChecked ? Math.min(walletBalance, billAmount) : 0;
  const onlineDue = Math.max(0, billAmount - appliedWallet);

  const cancellbill = async () => {
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, cancel it!',
    }).then((result) => {
      console.log('aad');
      setShow(false)
      if (result.isConfirmed) {
        setShow(false)
        cancelrequesr();
        Swal.fire('cancelled!', 'Your item has been cancelled.', 'success');
      }
    });

  }
  const cancelrequesr = async () => {
    try {
      const response = await axios.get(site_url + '/cancelrequesr/' + paymentdetails?.id + '/2');
      if (response.data.status == 'success') {
        userpayrequest();
      }
    } catch (error) {

    }
  }
  return (
    <div>




      <Navbar expand="lg" className="navbar px-3">

        <Navbar.Brand className="fw-bold text-white"><center><FaArrowLeft onClick={goBack} className="fs-5 text-white notificaton-icon" /> Payment</center></Navbar.Brand>
        <Nav className="ms-auto d-flex align-items-center">
        </Nav>
      </Navbar>
      <Container className="mt-3">

        <div>
          <img style={{ width: '100%' }} src='wall.jpg' />
          <center><h3>No Bills</h3></center>
          <center>
            <p style={{ fontSize: 17 }} className='text-danger mt-5'>If the payment popup is closed or a new payment request is received, please click the refresh button</p>
          </center>
        </div>

        <Modal show={show} onHide={handleClose} centered>
          <Modal.Header >
            <Modal.Title>Payment Request</Modal.Title>
          </Modal.Header>
          <Modal.Body >
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <div
                style={{
                  width: '60px',
                  height: '60px',
                  background: '#ff8f00',
                  borderRadius: '50%',
                  border: '2px solid white',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <IndianRupee size={30} color="white" />
              </div>
              <table style={{ width: '100%', marginTop: '10px', borderCollapse: 'collapse' }}>
                <tbody>
                  <tr>
                    <td style={{ padding: '8px', fontWeight: 'bold' }}>Store Name:</td>
                    <td>{paymentdetails?.shop_name}</td>
                  </tr>
                  <tr>
                    <td style={{ padding: '8px', fontWeight: 'bold' }}>Store Number:</td>
                    <td>{paymentdetails?.phone}</td>
                  </tr>
                  <tr>
                    <td style={{ padding: '8px', fontWeight: 'bold' }}>Total Bill Amount:</td>
                    <td><strong style={{ fontSize: '24px' }}>Rs.{paymentdetails?.billamount}</strong></td>
                  </tr>
                  <tr>
                    <td style={{ padding: '8px', fontWeight: 'bold' }}>Bill Number:</td>
                    <td>{paymentdetails?.billno}</td>
                  </tr>
                  <tr>
                    <td style={{ padding: '8px', fontWeight: 'bold' }}>Date/Time:</td>
                    <td>{paymentdetails?.date_time}</td>
                  </tr>
                </tbody>
              </table>


              <div className="row px-2">
                <div className="col-12" style={{ width: '100%' }}>
                  {walletBalance > 0 ? (
                    <div className="form-check mt-3" style={{ background: '#f8f9fa', padding: '15px 15px 15px 35px', borderRadius: '12px', border: '1px solid #e9ecef' }}>
                      <input
                        checked={isChecked}
                        onChange={handleCheckboxChange}
                        type="checkbox"
                        className="form-check-input"
                        id="rewardWalletCheck"
                        style={{ width: '20px', height: '20px', marginTop: '2px' }}
                      />
                      <label className="form-check-label ms-1" htmlFor="rewardWalletCheck" style={{ fontWeight: '600', color: '#333' }}>
                        Use Reward Points Wallet Rs.{walletBalance.toFixed(2)}
                      </label>
                      {isChecked && (
                        <div style={{ fontSize: '13px', marginTop: '8px', color: '#555' }}>
                          Wallet debit: Rs.{appliedWallet.toFixed(2)}<br />
                          {onlineDue > 0
                              ? <>Online to pay: Rs.{onlineDue.toFixed(2)}</>
                            : <strong style={{ color: '#28a745' }}>Full bill paid from wallet</strong>}
                        </div>
                      )}
                      {UserActivity?.data?.welcome_bonus_used == 1 && (
                        <div className="alert alert-warning mt-2 mb-0" role="alert" style={{ fontSize: '12px', padding: '8px', borderRadius: '8px' }}>
                          ⚠️ Welcome bonus already used. Only regular wallet balance available.
                        </div>
                      )}
                    </div>
                  ) : null}
                </div>
              </div>

              {/* Remarks Field */}
              <div className="mt-3" style={{ width: '100%' }}>
                <label htmlFor="remarks" style={{ fontWeight: '600', marginBottom: '8px', display: 'block', fontSize: '14px' }}>
                  Remarks (Optional - for your reference)
                </label>
                <textarea
                  id="remarks"
                  className="form-control"
                  rows="3"
                  placeholder="Enter any notes or remarks about this payment..."
                  value={remarks}
                  onChange={(e) => setRemarks(e.target.value)}
                  style={{
                    borderRadius: '8px',
                    border: '1px solid #ddd',
                    padding: '10px',
                    fontSize: '14px',
                    width: '100%'
                  }}
                />
                <small className="text-muted" style={{ fontSize: '12px' }}>
                  This will be saved with your order for future reference
                </small>
              </div>

              {/* Warning Text */}
              <div className="alert alert-warning mt-3 mb-0" role="alert" style={{
                fontSize: '13px',
                padding: '12px',
                borderRadius: '8px',
                marginTop: '15px',
                marginBottom: '15px',
                background: '#fff3cd',
                border: '1px solid #ffc107',
                color: '#856404',
                width: '100%'
              }}>
                <strong>⚠️ Important:</strong> Please make sure the details are correct before making the final payment.
              </div>

            </div>


          </Modal.Body>
          <Modal.Footer>

            <Button variant="primary" onClick={makePayment}>
              {onlineDue > 0 && isChecked
                ? <>Pay Rs.{onlineDue.toFixed(2)}  <Banknote size={20} color="white" /></>
                : isChecked && onlineDue <= 0
                  ? <>Pay with wallet  <Banknote size={20} color="white" /></>
                  : <>Confirm  <Banknote size={20} color="white" /></>}
            </Button>
            <div style={{ width: '100%' }}>
              <center>
                <b>--OR--</b>
              </center>
            </div>

            <Button style={{ width: '100%', height: 40 }} variant="danger" onClick={cancellbill}>
              Cancel  <Ban size={20} color="white" />
            </Button>
          </Modal.Footer>
        </Modal>
        <FloatRefreshButton onRefresh={handleRefresh} />
      </Container>
      <Footer />

    </div>
  )
}

export default Index